/* global hUrl */
import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

let sideScrollSlider = [] // スライダー格納用変数
let campaignSlideSwiper = null
let slideLoadCount = 0 // スライダーのロード数
window.slider = function () {
  // 常にスライダーにする

  const sideScrollSliderItem = document.querySelectorAll('.js-sideScrollSlider') // スライダー要素
  if (sideScrollSliderItem[0]) {
    sideScrollSliderCall(sideScrollSliderItem)
  }

  // PC時だけスライダーにする
  const sideScrollSliderPcItem = document.getElementsByClassName('js-sideScrollSliderPC') // PCスライダー要素
  if (sideScrollSliderPcItem[0]) {
    let slideActive = false
    if (window.matchMedia('(min-width:769px)').matches) {
      sideScrollSliderCall(sideScrollSliderPcItem)
      slideActive = true
    }
    window.addEventListener('resize', function (e) {
      if (slideActive && window.matchMedia('(max-width:768px)').matches) {
        for (const targetSlider of sideScrollSliderPcItem) {
          const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
          sideScrollSlider[sliderName].destroy()
        }
        slideActive = false
      } else if (!slideActive && window.matchMedia('(min-width:769px)').matches) {
        sideScrollSliderCall(sideScrollSliderPcItem)
        slideActive = true
      }
    })
  }

  // SP時だけスライダーにする
  const sideScrollSliderSpItem = document.getElementsByClassName('js-sideScrollSliderSP') // SPスライダー要素
  if (sideScrollSliderSpItem[0]) {
    let slideActive = false
    if (window.matchMedia('(max-width:768px)').matches) {
      sideScrollSliderCall(sideScrollSliderSpItem)
      slideActive = true
    }
    window.addEventListener('resize', function (e) {
      if (slideActive && window.matchMedia('(min-width:769px)').matches) {
        for (const targetSlider of sideScrollSliderSpItem) {
          const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
          sideScrollSlider[sliderName].destroy()
        }
        slideActive = false
      } else if (!slideActive && window.matchMedia('(max-width:768px)').matches) {
        sideScrollSliderCall(sideScrollSliderSpItem)
        slideActive = true
      }
    })
  }

  if (campaignSlideSwiper === null && document.getElementById('campaignSlide')) {
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.querySelector('#campaignSlide .js-sideScrollSlider')
    const sliderName = 'campaignSlide'
    campaignSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（campaignSlideSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 'auto', //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      spaceBetween: 12, //スライド同士の間隔を空ける
      loopAdditionalSlides: 20, //ループ演出用のクローン数を増やして安定化させる
      freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする

      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: true, // 操作されたら停止する
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          spaceBetween: 12, //スライド同士の間隔を空ける
        },
      },
    })
  }

  // sideScrollSliderInitを呼び出す
  function sideScrollSliderCall(sliderList) {
    for (const targetSlider of sliderList) {
      if (targetSlider.closest('#campaignSlide')) {
        // キャンペーンスライドは飛ばす
        continue
      }

      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      // スライド間隔を取得
      const slidePcMargin = parseInt(targetSlider.dataset.slidePcMargin, 10)
      const slideSpMargin = parseInt(targetSlider.dataset.slideSpMargin, 10)
      sideScrollSliderInit(targetSlider, sliderName, slidePcMargin, slideSpMargin)
    }
  }

  // Swiperを起動する
  function sideScrollSliderInit(targetSlider, sliderName, slidePcMargin, slideSpMargin) {
    // console.log(sliderName)
    if (sideScrollSlider[sliderName]) {
      // 定義済みならキャンセル
      return
    }
    sideScrollSlider[sliderName] = new Swiper(targetSlider, {
      effect: 'slide', // slide,fade,cube,coverflow
      init: false, // 自動で初期化しない（Swiper.init()で初期化）
      speed: 300, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 'auto', //表示数変更
      slidesPerGroup: 2,
      spaceBetween: slideSpMargin, //スライド同士の間隔を空ける
      freeMode: true, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
      grabCursor: true, // 掴みカーソル
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
      breakpoints: {
        // 指定px以上でオプション切り替え
        769: {
          spaceBetween: slidePcMargin, //スライド同士の間隔を空ける
          slidesPerView: 'auto', //表示数変更
          freeMode: false, //ドラッグ等でのスライド時、スライドが定位置以外で止まれるようにする
        },
      },
    })
    if (!targetSlider.dataset.nowValue) {
    }
    sideScrollSlider[sliderName]['firstLoad'] = false // 初回ロード完了フラグ
    sideScrollSlider[sliderName]['isLoad'] = false // ロード中フラグ
    sideScrollSlider[sliderName]['nextIndex'] = 0 // 次にロードする動画

    sideScrollSlider[sliderName].on('init', function () {
      if (sideScrollSlider[sliderName]['firstLoad'] || sideScrollSlider[sliderName]['isLoad']) {
        // 初回でないかロード中はスキップ
        return
      }
      sideScrollSlider[sliderName]['isLoad'] = true // ロード中
      if (~sliderName.indexOf('new')) {
        console.log('init')
      }
      moreSlide(sliderName, targetSlider)
    })
    sideScrollSlider[sliderName].on('reachEnd', function () {
      if (!sideScrollSlider[sliderName]['firstLoad'] || sideScrollSlider[sliderName]['isLoad']) {
        // ロード中か初回ロードが終わっていなければ待機
        return
      }
      sideScrollSlider[sliderName]['isLoad'] = true // ロード中

      // console.log({ sliderName })
      moreSlide(sliderName, targetSlider)
    })
    sideScrollSlider[sliderName].init()

    //  ###    ###   #####   #####    #####
    //  ## #  # ##  ##   ##  ##  ##   ##
    //  ##  ##  ##  ##   ##  #####    #####
    //  ##      ##  ##   ##  ##  ##   ##
    //  ##      ##   #####   ##   ##  #####

    function moreSlide(sliderName, targetSlider) {
      // スライド完了時のトリガー
      const slideMaxVal = targetSlider.dataset.slideMax ? parseInt(targetSlider.dataset.slideMax, 10) : 50 // 最大のスライド数　未指定50
      const slideNowVal = sideScrollSlider[sliderName]['firstLoad'] ? sideScrollSlider[sliderName].slides.length - 1 : 0 // 現在のスライド数

      const slideClass = targetSlider.dataset.slideClass // 現在のスライドクラス

      const slideUrl = targetSlider.dataset.slideMore // 追加スライドURL

      // console.log({ targetSlider })
      // console.log({ slideUrl, slideNowVal, slideMaxVal })
      if (!slideUrl || slideNowVal >= slideMaxVal) {
        return
      }

      const slideLoadVal = targetSlider.dataset.loadVal ? parseInt(targetSlider.dataset.loadVal, 10) : 5 // 読み込むスライド数

      if (~sliderName.indexOf('new')) {
        console.log({ slideNowVal })
        console.log(sideScrollSlider[sliderName]['nextIndex'])
      }
      if (sideScrollSlider[sliderName]['nextIndex'] >= slideNowVal + 1) {
        // 次に呼び出す動画番号が前より小さかったらキャンセル
        return
      }
      sideScrollSlider[sliderName]['nextIndex'] = slideNowVal + 1

      // 追加のスライドを構築する
      let slideContent = ''
      // 最初のスライドのHTMLを取得
      const firstSlide = targetSlider.getElementsByClassName('swiper-slide')[0]
        ? targetSlider.getElementsByClassName('swiper-slide')[0].innerHTML
        : `<div class="js-videoPreviewHover movieItem movieItem--top  anime key active fade-in textLink">
  <a href="" class="movieItem__img">
    <div class="movieImage ">
      <div class="md-lay block zoom">
        <div class="lay-bg">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA4CAMAAAA8cK3qAAAAA1BMVEW3t7eZ6ssfAAAAG0lEQVR42u3BAQEAAACCIP+vbkhAAQAAAADwZBYYAAH9tefDAAAAAElFTkSuQmCC" width="810" height="458" alt="">
        </div>
      </div>
    </div>
  </a>
  <div class="movieItem__data flex vcenter break">
    <a href="" class="movieItem__title textLin">
      ――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――――</a>
    <div class="movieItem__topInfo flex vcenter">
      <div class="movieItem__price movieItem__price--ppv movieItem__price--top">
        ―――――
      </div>
      <a href="/model/?id=aina_takahashi">――――――</a>
    </div>
    <div class="movieItem__sep"></div>
    <div class="movieItem__time movieItem__time--top">
      00:00:00 </div>
    <div class="movieItem__like movieItem__like-- flex vcenter notranslate" style="margin-right: 1rem;">
      <i class="topMv__icon icon-like"></i>
      <span>0</span>
    </div>
    <div class="movieItem__star flex vcenter notranslate">
      <i class="topMv__icon icon-star"></i>
      ―――
    </div>
  </div>
</div>`

      for (
        let index = sideScrollSlider[sliderName]['nextIndex'];
        index <= sideScrollSlider[sliderName]['nextIndex'] + slideLoadVal;
        index++
      ) {
        const slideID = 'moreSlide-' + sliderName + '-' + index
        // console.log(slideID)
        slideContent += `<div class="swiper-slide"><div id="${slideID}">
        <div class="movieItem__loading md-loading active"></div>
        <div class="addSlide"><div class="is-hidden">${firstSlide}</div></div>
</div></div>`
        if (index >= slideMaxVal) {
          break
        }
      }
      // console.log({ slideContent })
      // console.log({ sliderName })
      sideScrollSlider[sliderName].appendSlide(slideContent)
      // Ajaxで中身を呼び出す

      if (slideUrl !== '') {
        const ajaxWaitTimer = setInterval(() => {
          // スライドのロード数が2箇所未満になるまで待機
          if (slideLoadCount < 2) {
            ++slideLoadCount // カウント数を増やす
            applyAjax(
              slideUrl,
              'index=' + sideScrollSlider[sliderName]['nextIndex'] + '&value=' + slideLoadVal + '&class=' + slideClass,
              sideScrollSlider[sliderName]['nextIndex'],
              slideLoadVal,
              sliderName
            )
            clearInterval(ajaxWaitTimer) // 待機タイマー削除
          }
        }, 300)
      }
    }

    /*
     ###          ##    ###    ##     ##
   ##   ##        ##  ##   ##    ## ##
  ##     ##       ## ##     ##    ###
  ######### ##    ## #########   ## ##
  ##     ##  ######  ##     ## ##     ##
  */

    /**
     * Ajax処理を実行する
     * @param url {string} 取得先のURL
     * @param param {string} パラメータ
     * @param nextSlide {int} 開始ID
     * @param slideLoadVal {int} ロード数
     */
    function applyAjax(url, param, nextSlide, slideLoadVal, sliderName) {
      // console.log({ url, param, nextSlide, slideLoadVal })
      let ajax = new XMLHttpRequest() // Ajaxリクエスト

      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open('get', url, true) // GET/POST, URL, 非同期処理

      // console.log(url)

      ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxアクセスを明示するリクエストヘッダー
      // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
      // ajax.setRequestHeader('Pragma', 'no-cache')
      // ajax.setRequestHeader('Cache-Control', 'no-cache')
      // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')

      // console.log(url)

      ajax.responseType = 'document' // 取得タイプ document text json
      ajax.timeout = 60000 // タイムアウト判定時間

      ajax.send() // GETリクエスト実行

      ajax.onload = function () {
        // アクセス成功
        if (ajax.status < 200 || ajax.status >= 400) {
          console.log('Error: Code ' + ajax.status) // エラー
          return
        }

        // 取得結果を反映

        if (~url.indexOf('new')) {
          console.log(url)
        }

        const movieList = ajax.response.getElementsByClassName('js-addSlide')
        // console.log(movieList)

        // DOMを文字列に変換
        // const serializer = new XMLSerializer()
        // const convertedHTML = serializer.serializeToString(movieList)
        // console.log(convertedHTML)

        // console.log({ sliderName })
        if (movieList[0]) {
          // console.log({ movieList })
          let movieCount = 0
          for (let index = nextSlide; index <= nextSlide + slideLoadVal; index++) {
            const slideID = 'moreSlide-' + sliderName + '-' + index
            const target = document.getElementById(slideID)
            // console.log({ slideID, target })
            if (!target) {
              continue
            }
            if (movieList[movieCount]) {
              target.outerHTML = movieList[movieCount].innerHTML
            } else {
              target.outerHTML = ''
            }
            ++movieCount
          }

          // 空のスライドを消す
          const slideList = document.querySelectorAll('[data-slide="' + sliderName + '"] .swiper-slide')
          for (const slide of slideList) {
            if (!slide.hasChildNodes()) {
              // 子要素がないスライドを削除
              slide.parentNode.removeChild(slide)
            }
          }
          sideScrollSlider[sliderName].update() // スライダーを更新
        } else {
          // 動画が返ってこなかった場合はスライドを消す
          for (let index = nextSlide; index <= nextSlide + slideLoadVal; index++) {
            const slideID = 'moreSlide-' + sliderName + '-' + index
            const target = document.getElementById(slideID)
            if (target) {
              target.parentNode.removeChild(target)
            }
          }

          if (nextSlide === 1) {
            // 有効なスライドがなければ表示変更
            sideScrollSlider[sliderName].destroy()

            // 親セクションを探して消す
            const section = document.querySelector('[data-slide="' + sliderName + '"]').closest('.js-slideClose')
            console.log({ sliderName })
            console.log({ section })
            if (section) {
              section.parentNode.removeChild(section)
              // section.style.background = 'red'
            }
          }
        }

        sideScrollSlider[sliderName]['firstLoad'] = true // 初回ロード完了
        sideScrollSlider[sliderName]['isLoad'] = false // ロード完了
      }
      ajax.ontimeout = function (e) {
        // タイムアウト
      }
      ajax.onerror = function () {
        // Ajax処理失敗
      }
      ajax.onloadend = function () {
        // 受信成否に関わらず実行
        --slideLoadCount // カウント数を減らす
        window.videoPreview()
        ajax = false
      }
    }
  }

  //  ##  ###    ###    ###     ####    #####
  //  ##  ## #  # ##   ## ##   ##       ##
  //  ##  ##  ##  ##  ##   ##  ##  ###  #####
  //  ##  ##      ##  #######  ##   ##  ##
  //  ##  ##      ##  ##   ##   ####    #####
  if (document.getElementById('imageSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const slideItem = document.getElementById('imageSlide')
    const sliderName = 'imageSlide'
    const imageSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（imageSlideSwiper.init()で初期化）
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      autoHeight: true, // スライドごとに高さを変動させる
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })

    let lastSlide = null
    window.addEventListener('click', function (e) {
      // 指定のクラスを持つ
      if (e.target.classList.contains('js-slideShift')) {
        const slide = parseInt(e.target.dataset.slide, 10)
        if (lastSlide === slide) {
          return
        }
        imageSlideSwiper.slideTo(slide)
        imageSlideSwiper.slideNext()
        lastSlide = slide
      }
    })
  }

  //  ##   ##   #####   ######
  //  ##   ##  ##   ##    ##
  //  #######  ##   ##    ##
  //  ##   ##  ##   ##    ##
  //  ##   ##   #####     ##

  let keywordSlider = []
  const keywordSliderItem = document.getElementsByClassName('js-keywordSlider')
  if (keywordSliderItem[0]) {
    for (const targetSlider of keywordSliderItem) {
      const sliderName = targetSlider.dataset.slide // data-slideからスライド名を取得
      keywordSliderInit(targetSlider, sliderName)
    }
  }
  function keywordSliderInit(targetSlider, sliderName) {
    keywordSlider[sliderName] = new Swiper(targetSlider, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 800, // アニメ速度
      loop: false, // ループ
      centeredSlides: false, // 中央のスライドを基準にする
      // loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 'auto', //表示数変更
      spaceBetween: 5, //スライド同士の間隔を空ける

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}

window.slider()
